export const ORIGINAL_SOURCE = {
  PortalGenerated: 'PortalGenerated',
  DeviceDetected: 'DeviceDetected',
};

const ORIGINAL_SOURCE_MAPPING = [
  {
    value: ORIGINAL_SOURCE.PortalGenerated,
    label: 'Generated',
    color: '#87C8E0',
  },
  {
    value: ORIGINAL_SOURCE.DeviceDetected,
    label: 'Detected',
    color: '#9CA3AF',
  },
];

export const getOriginalSourceLabel = value =>
  ORIGINAL_SOURCE_MAPPING.find(item => item.value === value)?.label ?? '';

export const getOriginalSourceColor = value =>
  ORIGINAL_SOURCE_MAPPING.find(item => item.value === value)?.color ?? '#9CA3AF';

export const getOriginalSourceOptions = () =>
  ORIGINAL_SOURCE_MAPPING.map(({ value, label }) => ({ value, label }));

export const isPortalGenerated = value => value === ORIGINAL_SOURCE.PortalGenerated;
